import { JSEncrypt } from "jsencrypt";
import SpecificExceptions from "./specific-exceptions";
import GenericExceptions from "./generic-exceptions";
const win = window;
// const FORGOT_ACC_PORTAL_DOMAIN = window.FORGOT_ACC_PORTAL_DOMAIN; // in dev for example value is: "http://sdea004:8080";
var serverURL = win["base_portal_url"];
const cem_key = win['CEM_KEY'];
export async function callBackendService(
  url,
  requestBody,
  methodType,
  { ...extraHeader }
) {
  // console.log("callBackendService :: Enter");
  // console.log("callBackendService :: param :: url => " + url);
  // console.log("callBackendService :: param :: requestBody => " + JSON.stringify(requestBody));
  // console.log("callBackendService :: param :: methodType => " + JSON.stringify(methodType));
  // console.log("callBackendService :: param :: extraHeader => " + JSON.stringify(extraHeader);

  let headers = {
    "Content-Type": "application/json",
    //'Authorization': 'Bearer '+this.props.token,
    "cem-key": cem_key
  };
  if (extraHeader) {
    headers = { ...headers, ...extraHeader };
  }

  // console.log("callBackendService :: Headers => " + JSON.stringify(headers));

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: methodType,
      body: JSON.stringify(requestBody),
      headers: headers,
    })
      .then(async (res) => res.json())

      .then(async (result) => {

        let responseStatus = {};
        console.log("BackEnd :: Result => " + JSON.stringify(result));
        if (url.includes("username") || url.includes("verify/client")) {
          responseStatus.code = result.status.code;
          responseStatus.message = result.status.message;
          responseStatus.arabicDetail = result.status.arabicDetail;
          responseStatus.englishDetail = result.status.englishDetail;
        } else {
          responseStatus.code = result.status.code;
          responseStatus.message = result.status.message;
          responseStatus.arabicDetail = result.status.arabicDetail;
          responseStatus.englishDetail = result.status.englishDetail;
        }
        if (responseStatus && responseStatus.code !== "MAPI-000") {
          if (responseStatus.code === "MAPI-500") {
            // console.log("BackEnd :: Result :: GenericExceptions");
            reject(new GenericExceptions(responseStatus.detail));

            //reject(responseStatus.message);
          } else if (responseStatus.code === "MAPI-020") {
            // console.log("BackEnd :: Result :: MAPI-020 Invalid Mobile Format");

            if (window.lang === "en") {
              // ENGLISH LANGUAGE
              reject(
                new SpecificExceptions(
                  responseStatus.code,
                  "Invalid number"
                )
              );
            } else {
              // ARABIC LANGUAGE
              reject(
                new SpecificExceptions(
                  responseStatus.code,
                  "الرقم غير صحيح"
                )
              );
            }

            //reject(responseStatus.message);
          } else if (responseStatus.code === "MAPI-030") {
            // console.log("BackEnd :: Result :: MAPI-030 Call Center Exceptions");

            if (window.lang === "en") {
              // ENGLISH LANGUAGE
              reject(
                new SpecificExceptions(
                  responseStatus.code,
                  "Customer service is always here\n\nTo use mobily services and access the portal, please call customer care on 1100 to update your information.\n\n"
                )
              );
            } else {
              // ARABIC LANGUAGE
              reject(
                new SpecificExceptions(
                  responseStatus.code,
                  "خدمة العملاء موجودون دائمًا لخدمتك\n\n" +
                  "لاستخدام خدمات موبايلي والدخول إلى البوابة الإلكترونية، يرجى الاتصال بخدمة العملاء 1100 لتحديث معلوماتك\n\n."
                )
              );
            }

            //reject(responseStatus.message);
          } else {
            // console.log("BackEnd :: Result :: SpecificExceptions");

            if (window.lang === "en") {
              // ENGLISH LANGUAGE
              reject(
                new SpecificExceptions(
                  responseStatus.code,
                  responseStatus.englishDetail
                )
              );
            } else {
              // ARABIC LANGUAGE
              reject(
                new SpecificExceptions(
                  responseStatus.code,
                  responseStatus.arabicDetail
                )
              );
            }
          }
        }
        resolve(result);
      })
      .catch((err) => {
        //reject(err)
        reject("Generic error - please try agian ...");

        console.log("BackEnd :: catch => " + err);
        console.log(err);
        //throw new Error("Generic error - please try agian ...")
      });
  });
}

export function encrypt(message) {
  // console.log("encrypt :: Enter");
  // console.log("encrypt :: param :: message => " + message);
  const publicKey = window.PK;
  let RSAEncrypt = new JSEncrypt();
  RSAEncrypt.setPublicKey(publicKey);
  let encryptedMessage = RSAEncrypt.encrypt(message);

  // console.log("encrypt :: encryptedMessage => " + encryptedMessage);

  return encryptedMessage;
}

export function reGenerateToken() {
  let reGenerateToken = window.reGenerateToken;

  return new Promise((resolve, reject) => {
    console.log(serverURL + reGenerateToken);

    fetch(serverURL + reGenerateToken, {
      method: "GET",
      headers: {
        "Content-type": "application/x-www-form-urlencoded",
        "cem-key": cem_key
      },
    })
      .then((res) => res.text())
      .then((result) => {
        resolve(result);
        console.log(result);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}
